import axios from "axios";
import Config from "./Config";
import { toast } from "sonner";
const TOKEN = Config.getToken();

const { API_BASE_URL } = Config;

// ===================Edit Address data================
export const AddAddress = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.post(`${API_BASE_URL}/user/address`, data, {
      headers,
    });

    if (response.data.status === true) {
      toast.success(response.data.message);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error updating Address data:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to update Address data. Please try again.");
    throw error;
  }
};
// =========================getAddressdataById=========================
export const getAddressById = async () => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.get(`${API_BASE_URL}/user/address`, {
      headers,
    });

    if (response.data.status === true) {
      return response.data.responseData;
    } else {
      toast.error(response.data.message || "Unexpected API response");
      throw new Error(response.data.message || "API returned an error");
    }
  } catch (error) {
    console.error(
      "Error fetching Address data:",
      error.response || error.message || error
    );
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to fetch Address data. Please try again later.");
    throw error;
  }
};

// ===================Edit Address data================
export const UpdateAddress = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.put(`${API_BASE_URL}/user/address`, data, {
      headers,
    });

    if (response.data.status === true) {
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error updating Address data:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to update Address data. Please try again.");
    throw error;
  }
};

// ===================Edit Address data================
// ===================Delete Address================
export const DeleteAddress = async (data) => {
  const TOKEN = Config.getToken();
  const headers = {
    Authorization: `Bearer ${TOKEN}`,
    "Content-Type": "application/json",
  };
  try {
    const response = await axios.delete(`${API_BASE_URL}/user/address`, {
      headers,
      data,
    });

    if (response.data.status === true) {
      toast.success(response.data.message);
      return response.data;
    } else {
      toast.error(response.data.message);
      throw new Error(response.data.message);
    }
  } catch (error) {
    console.error("Error deleting Address data:", error);
    if (error.response?.data?.message === "Unauthorized - Token verification failed") {
      Config.handleUnauthorized();
      return;
    }
    toast.error("Failed to delete Address data. Please try again.");
    throw error;
  }
};

